import { defaultMsgExpireDuration } from '@/configs/options';

export function genUserSettings() {
  return {
    global_search: '1',
    call_in: '1',
    message_in: '1',
    expire_duration: defaultMsgExpireDuration,
  };
}
